import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Loading from '.';

const useStyles = makeStyles(() => createStyles({
  root: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function LoadingPage({ color }: { color?: string }) {
  const classes = useStyles();
  return (
    <div className={classes.root} style={{ background: color }}>
      <Loading />
    </div>
  );
}
